/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function FieldEmailSmall(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'FieldEmailSmall',
      'aria-hidden': true,
      focusable: false,
      width:  15 * scale,
      height: 12 * scale,
      viewBox: '0 0 15 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M14 1.8c-.2-.5-.5-.8-1-.8H2c-.5 0-.8.3-1 .8l6.5 4.4zM7.5 8.4 1 3.9V10c0 .5.5 1 1 1h11c.5 0 1-.5 1-1V3.9z"}))
}
